<template>

  <div class="text-center">
    <div class="title">
      <h1>Описание проекта</h1>
      <p>Мы так много времени уделяем клиентам, что, к сожалению, не успели как следует заполнить раздел портфолио. Вы нас поймали, поэтому если в форме обратной связи ниже вы впишете комментарий «Пустое портфолио» - мы сделаем вам проект с 15% скидкой.</p>
    </div>
    <section class="section">
      <div class="container">
        <div class="block-center">
            <Feedback />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
const name = "Home"

import Feedback from '@/components/Feedback.vue'

export default {
  name,
  components: {
    Feedback
  }
}

</script>
